import App from './app'
import Home2 from './pages/Home2'
import Jobs from './pages/Jobs'
import Invoice from './pages/Invoice'
import Report from './pages/Report'
import Settings from './pages/Settings'
import Job from './pages/Job'
import Calendar from './pages/Calendar'

export const paths = {
    FINANCE: '/',
    SIGN_IN: '/',
    //PAGE: '/home',
    JOBS: '/jobs',
    JOB: '/job/:sheet/:view',
    SUPPLIERS: '/suppliers',
    REPORT: '/report',
    SETTINGS: '/settings',
    INVOICE: '/invoice/:uid/:job',
    QUOTE: '/quote/:uid/:job',
    CALENDAR: '/calendar',
    LOGIN: '/login',
    REGISTER: '/register'
};

const requireAuth = getState => {
    return (nextState, replace) => {
        // if (!isAuthenticated(getState())) {
        //     replace(paths.SIGN_IN)
        // }
    }
}

const requireUnauth = getState => {
    return (nextState, replace) => {
        // if (isAuthenticated(getState())) {
        //     //replace(paths.JOBS)
        // }
    }
}

export const getRoutes = getState => {
    return {
        path: paths.ROOT,
        component: App,
        childRoutes: [
            {
                indexRoute: {
                    component: Home2,
                    onEnter: requireUnauth(getState)
                }
            },
            {
                path: paths.SIGN_IN,
                component: Home2
            },
            {
                path: paths.LOGIN,
                component: Home2
            },
            {
                path: paths.REGISTER,
                component: Home2
            },
            {
                path: paths.CALENDAR,
                component: Calendar
            },
            {
                path: paths.JOBS,
                component: Jobs
            },
            {
                path: paths.JOB,
                component: Job
            },
            {
                path: paths.REPORT,
                component: Report
            },
            {
                path: paths.SETTINGS,
                component: Settings
            },
            {
                path: paths.INVOICE,
                component: Invoice
            },
            {
                path: paths.QUOTE,
                component: Invoice
            }
        ]
    }
}



// WEBPACK FOOTER //
// ./src/views/routes.js